export const NARROW_WINDOW_WIDTH = 500;
